// Batch 34 · fork I — B34-11: the "Docs" count on the vouching / SURL sheets opens the linked document(s) read-only. EN + AR.
export const I18N_B34I = {
  en: {
    b34i: {
      openDocs: "Open the linked document(s)",
      title: "Linked documents",
      titleOne: "Linked document",
      choose: "Choose a document to open",
      docRef: "DOC ref",
      fileName: "File name",
      type: "Type",
      reference: "Reference",
      uploaded: "Uploaded",
      extractedRef: "Extracted reference",
      amounts: "Amount read from the document",
      net: "Net", vat: "VAT", gross: "Gross",
      notRead: "not read",
      openInDocuments: "Open in Documents tab",
      back: "Back to the list",
      close: "Close",
      download: "Download",
      noPreview: "No preview for this file type — download it to open it.",
      demoDoc: "Sample document — no file stored.",
      loading: "Loading…",
      notAvailable: "This document cannot be opened (deleted, or you have no access to it).",
      readOnly: "Read only — the document stays stored once, in the Documents tab.",
      downloadFailed: "Could not open the file.",
    },
  },
  ar: {
    b34i: {
      openDocs: "فتح المستند (المستندات) المرتبطة",
      title: "المستندات المرتبطة",
      titleOne: "المستند المرتبط",
      choose: "اختر مستندًا لفتحه",
      docRef: "مرجع المستند",
      fileName: "اسم الملف",
      type: "النوع",
      reference: "المرجع",
      uploaded: "تاريخ الرفع",
      extractedRef: "المرجع المستخرج",
      amounts: "المبلغ المقروء من المستند",
      net: "الصافي", vat: "ضريبة القيمة المضافة", gross: "الإجمالي",
      notRead: "غير مقروء",
      openInDocuments: "فتح في تبويب المستندات",
      back: "العودة إلى القائمة",
      close: "إغلاق",
      download: "تنزيل",
      noPreview: "لا تتوفر معاينة لهذا النوع من الملفات — نزّله لفتحه.",
      demoDoc: "مستند نموذجي — لا يوجد ملف مخزّن.",
      loading: "جارٍ التحميل…",
      notAvailable: "لا يمكن فتح هذا المستند (محذوف، أو ليس لديك صلاحية الوصول إليه).",
      readOnly: "للقراءة فقط — يبقى المستند مخزّنًا مرة واحدة في تبويب المستندات.",
      downloadFailed: "تعذّر فتح الملف.",
    },
  },
};

export default I18N_B34I;
